<template>
  <div>
    <v-dialog v-model="show" persistent max-width="900" content-class="dialog-form-customer">
      <v-card outlined>
        <v-form @submit.prevent="onSubmitForm()" ref="form">
          <v-card-title :class="`justify-between ${customerTypeString.code == 1
            ? 'blue text-white'
            : 'green text-white'
            }`">
            <div>
              <span v-if="event == 'create'">
                <v-icon left dark>mdi-plus-box-multiple</v-icon>{{ $t('customer.add_trader_data') }}
              </span>
              <span v-else>
                <v-icon left dark>mdi-pencil</v-icon>{{ $t('customer.customer_information') }}
              </span>
              <span class="text-sm">({{ customerTypeString.text }})</span>
            </div>
            <v-btn elevation="0" color="white" @click="show = false" icon small v-show="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="dialog-form-customer-in overflow-y-auto">
            <v-overlay absolute v-if="isLoading" opacity="0.7" color="white">
              <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
            </v-overlay>
            <div class="px-2" v-if="!isLoading">
              <div class="grid grid-cols-1 gap-2" v-if="customerTypeString.code == 2">
                <CardReaderBox />
                <h3 class="my-5">{{ $t('customer.general_personal_data') }}</h3>
                <div class="grid grid-cols-5 gap-2">
                  <div>
                    <span>{{ $t('account.prefix') }}</span>
                    <v-combobox
                      flat
                      background-color="grey lighten-4"
                      solo
                      v-model="form.title"
                      :items="prefixName"
                      :label="$t('account.prefix')"
                      item-text="text"
                      item-value="text"
                      :return-object="false"
                    >
                    </v-combobox>
                  </div>
                  <div class="col-span-2">
                    <span>{{ $t('account.first_name') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.first_name')" v-model="form.firstName"
                      :rules="[rules.required]"></v-text-field>
                  </div>
                  <div class="col-span-2">
                    <span>{{ $t('account.last_name') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.last_name')" required
                      v-model="form.lastName"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.nick_name') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.nick_name')" required
                      v-model="form.nickName"></v-text-field>
                  </div>
                  <div>
                    <span>{{ $t('account.date_of_birth_label') }}</span>
                    <v-menu ref="birthDateMenu" v-model="birthDate" :close-on-content-click="false"
                      :return-value.sync="form.dateOfBirth" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(form.dateOfBirth)" :label="$t('validate.click_here_to_select_date')"
                          prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" flat
                          background-color="grey lighten-4" solo></v-text-field>
                      </template>
                      <v-date-picker v-model="form.dateOfBirth" no-title scrollable
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" locale="th"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="birthDate = false">{{ $t('cancel') }}</v-btn>
                        <v-btn text color="success" @click="$refs.birthDateMenu.save(form.dateOfBirth)">{{ $t('ok') }}</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.gender') }}</span>
                    <v-select flat v-model="form.gender" :items="[
                      { title: $t('account.male'), value: 'm' },
                      { title: $t('account.female'), value: 'f' },
                    ]" item-text="title" item-value="value" background-color="grey lighten-4" solo :label="$t('account.gender')"
                      required :no-data-text="$t('noinfo')"></v-select>
                  </div>
                  <div>
                    <span>{{ $t('account.nationality') }}</span>
                    <v-autocomplete flat v-model="form.nationality" :items="jsonNationality" item-text="title"
                      item-value="id" background-color="grey lighten-4" solo :label="$t('account.nationality')" required>
                      <template v-slot:item="{ item }">
                        {{ $t(`nationalities.${item.id}`) }}
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ $t(`nationalities.${item.id}`) }}
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.religion') }}</span>
                    <v-combobox
                      flat
                      v-model="form.religion"
                      :items="jsonReligion"
                      item-text="text"
                      item-value="value"
                      background-color="grey lighten-4"
                      solo
                      :label="$t('account.religion')"
                      required
                      :return-object="false"
                    >
                      <template v-slot:selection="{ item }">
                        {{ $te(`religion.${item}`) ? $t(`religion.${item}`) : item }}
                      </template>
                    </v-combobox>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.marital_status') }}</span>
                    <v-select flat v-model="form.marriageStatus" :items="[
                      { title: $t('account.single'), value: 'โสด' },
                      { title: $t('account.married'), value: 'สมรส' },
                      { title: $t('account.divorced'), value: 'หย่า' },
                      { title: $t('account.widowed'), value: 'หม้าย' },
                    ]" item-text="title" item-value="value" background-color="grey lighten-4" solo :label="$t('account.marital_status')"
                      required :no-data-text="$t('noinfo')"></v-select>
                  </div>
                  <div>
                    <span>{{ $t('account.spouse_name_if_married') }}</span>
                    <v-text-field flat v-model="form.marriageName" background-color="grey lighten-4" solo
                      :label="$t('account.spouse_name')" :disabled="form.marriageStatus != $t('account.married') ||
                        form.marriageStatus == ''
                        " required></v-text-field>
                  </div>
                </div>
                <!-- div.grid.grid-cols-2.gap-2>div*2 -->
                <div class="grid grid-cols-2 gap-2">
                  <EditTaxId showLabel :showWarning='customerTypeString.code == 2 ? true : false'
                    :getLabel="$t('account.citizen_id_label')" v-model='form.citizenId' :getIsVat="false"
                    @input="form.citizenId = $event" :getRules="rules" :isCreate="event == 'create' ? true : false" />
                  <div>
                    <span>{{ $t('account.laser_id_label') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.laser_id_label_no_en')"
                      v-model="form.citizenCardLaserNo"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.issue_date_card') }}</span>
                    <v-menu ref="citizenCardIssueDate" v-model="citizenCardIssueMenu" :close-on-content-click="false"
                      :return-value.sync="form.citizenCardIssueDate" transition="scale-transition" offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(form.citizenCardIssueDate)"
                          :label="$t('validate.click_here_to_select_date')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                          v-on="on" flat background-color="grey lighten-4" solo></v-text-field>
                      </template>
                      <v-date-picker v-model="form.citizenCardIssueDate" no-title scrollable
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" locale="th"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="citizenCardIssueMenu = false">{{ $t('cancel') }}</v-btn>
                        <v-btn text color="success" @click="
                          $refs.citizenCardIssueDate.save(
                            form.citizenCardIssueDate
                          )
                          ">{{ $t('ok') }}</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div>
                    <span>{{ $t('account.expire_date_card_another_form') }}</span>
                    <v-menu ref="citizenCardExpiryDate" v-model="citizenCardMenu" :close-on-content-click="false"
                      :return-value.sync="form.citizenCardExpiryDate" transition="scale-transition" offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(form.citizenCardExpiryDate)"
                          :label="$t('validate.click_here_to_select_date')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                          v-on="on" flat :hint="$t('validate.no_need_to_specify_if_it_is_lifetime_expiration_date')" background-color="grey lighten-4"
                          solo append-icon="mdi-close" @click:append="form.citizenCardExpiryDate = null"></v-text-field>
                      </template>
                      <v-date-picker v-model="form.citizenCardExpiryDate" no-title scrollable locale="th"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click="citizenCardMenu = false">{{ $t('cancel') }}</v-btn>
                        <v-btn text color="success" @click="
                          $refs.citizenCardExpiryDate.save(
                            form.citizenCardExpiryDate
                          )
                          ">{{ $t('ok') }}</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('account.passport_number') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.passport_number')"
                      v-model="form.passportId"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('customer.customer_profile_only') }}</span>
                    <v-file-input ref="profileImage" accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                      :label="$t('customer.customer_profile_only')" @change="uploadFile($event, form.profileImages_tmp)" flat v-model="profileImage_tmp"
                      background-color="grey lighten-4" solo></v-file-input>
                    <div class="image-list-box" v-if="form.profileImages_tmp && form.profileImages_tmp.length">
                      <div outlined v-for="(citizen, index) of form.profileImages_tmp" :key="`profilexx_${index}`"
                        class="image-list-box-in">
                        <img v-if="citizen.isCardReader" :src="'data:image/png;base64,' + citizen.imageData" />
                        <template v-else>
                          <img v-if="$helper.isImage(citizen.url)" :src="citizen.url" />
                          <div v-else class="file-box">
                            <div>
                              <div class="file-name">{{ (citizen.name).split('.')[0] }}</div>
                              <div>.{{ (citizen.name).split('.')[1] }}</div>
                            </div>
                          </div>
                        </template>
                        <v-btn small elevation="0" color="error" icon
                          @click="form.profileImages_tmp.splice(`${index}`, 1)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span>{{ $t('customer.citizen_card_images') }}</span>
                    <v-file-input ref="citizenImage" accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :label="$t('customer.citizen_card_images')" @change="uploadFile($event, form.citizenCardImages_tmp)" v-model="citizenImage_tmp"
                      flat background-color="grey lighten-4" solo></v-file-input>
                    <div class="image-list-box" v-if="form.citizenCardImages_tmp && form.citizenCardImages_tmp.length">
                      <div outlined v-for="(citizen, index) of form.citizenCardImages_tmp" :key="`profilexx_${index}`"
                        class="image-list-box-in">
                        <img v-if="$helper.isImage(citizen.url)" :src="citizen.url" />
                        <div v-else class="file-box">
                          <div>
                            <div class="file-name">{{ (citizen.name).split('.')[0] }}</div>
                            <div>.{{ (citizen.name).split('.')[1] }}</div>
                          </div>
                        </div>
                        <v-btn small elevation="0" color="error" icon
                          @click="form.citizenCardImages_tmp.splice(`${index}`, 1)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('account.education_level') }}</span>
                    <v-radio-group v-model="form.educateLevel">
                      <v-radio :label="$t('education_level.primary_school')" value="ประถมศึกษา"></v-radio>
                      <v-radio :label="$t('education_level.secondary_school')" value="มัธยมศึกษา"></v-radio>
                      <v-radio :label="$t('education_level.diploma')" value="อนุปริญญาหรือเทียบเท่า"></v-radio>
                      <v-radio :label="$t('education_level.bachelor')" value="ปริญญาหรือเทียบเท่า"></v-radio>
                      <v-radio :label="$t('education_level.higher_than_bachelor')" value="สูงกว่าปริญญาตรี"></v-radio>
                    </v-radio-group>
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.general_contact_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <template v-for="(tel, index) in form.tels_tmp">
                      <PhoneNumber
                        ref="inputPhoneNumber"
                        :tel.sync="form.tels_tmp[index]"
                        :interTel.sync="form.interTels_tmp[index]"
                        flat 
                        background-color="grey lighten-4" 
                        solo 
                        :phoneLabel="`${$t('account.phone_number')} #${index + 1}`"
                        required
                        type="text"
                        :append-icon="index - 1 < 0 ? `mdi-plus` : `mdi-minus`"
                        @click:append="index - 1 < 0 ? form.tels_tmp.push('') : removeTel(index)"
                      />
                    </template>
                  </div>
                  <div>
                    <template v-for="(email, index) in form.emails_tmp">
                      <span>{{ $t('account.email') }} #{{ index + 1 }}</span>
                      <v-text-field flat background-color="grey lighten-4" v-model="form.emails_tmp[index]"
                        :key="`mailxx` + index" solo :label="$t('account.email')" required @click:append="
                          index - 1 < 0
                            ? form.emails_tmp.push('')
                            : removeEmail(index)
                          " :append-icon="index - 1 < 0 ? `mdi-plus` : `mdi-minus`"></v-text-field>
                    </template>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('website') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('website')"
                      v-model="form.website"></v-text-field>
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.address_according_to_citizen_card') }}</h3>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('project.house_number_or_building_name_village') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('project.address_line_one')"
                      v-model="form.addressStreet"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('address.sub_district_or_district') }}</span>
                    <addressinput-subdistrict v-model="form.addressSubDistrict" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                  <div>
                    <span>{{ $t('address.amphoe_or_zone') }}</span>
                    <addressinput-district v-model="form.addressDistrict" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('project.province') }}</span>
                    <addressinput-province v-model="form.addressProvince" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                  <div>
                    <span>{{ $t('project.postal_code') }}</span>
                    <addressinput-zipcode v-model="form.addressZipcode" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" type="text" />
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.address_according_to_house_registration') }}</h3>
                  <!-- checkbox -->
                  <v-checkbox v-model="addressIsSame1" :label="$t('customer.use_citizen_card_address')"></v-checkbox>
                </div>
                <v-card :disabled="addressIsSame1" flat>
                  <div class="grid grid-cols-1 gap-2">
                    <div>
                      <span>{{ $t('project.house_number_or_building_name_village') }}</span>
                      <v-text-field flat background-color="grey lighten-4" solo :label="$t('project.address_line_one')"
                        v-model="form.addressHouseStreet"></v-text-field>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-2">
                    <div>
                      <span>{{ $t('address.sub_district_or_district') }}</span>
                      <addressinput-subdistrict v-model="form.addressHouseSubDistrict" :store="store2" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                    <div>
                      <span>{{ $t('address.amphoe_or_zone') }}</span>
                      <addressinput-district v-model="form.addressHouseDistrict" :store="store2" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-2">
                    <div>
                      <span>{{ $t('project.province') }}</span>
                      <addressinput-province v-model="form.addressHouseProvince" :store="store2" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                    <div>
                      <span>{{ $t('project.postal_code') }}</span>
                      <addressinput-zipcode v-model="form.addressHouseZipcode" :store="store2" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" type="text" />
                    </div>
                  </div>
                </v-card>
                <div>
                  <h3 class="my-5">{{ $t('customer.address_can_contact') }}</h3>
                  <v-checkbox v-model="addressIsSame2" :label="$t('customer.use_citizen_card_address')" hide-details></v-checkbox>
                  <v-checkbox v-model="addressIsSame3" :label="$t('customer.use_house_registration_address')" hide-details></v-checkbox>
                </div>
                <v-card :disabled="addressIsSame2 || addressIsSame3" flat>
                  <div class="grid grid-cols-1 gap-2">
                    <div>
                      <span>{{ $t('project.house_number_or_building_name_village') }}</span>
                      <v-text-field flat background-color="grey lighten-4" solo :label="$t('project.address_line_one')"
                        v-model="form.addressContactStreet"></v-text-field>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-2">
                    <div>
                      <span>{{ $t('address.sub_district_or_district') }}</span>
                      <addressinput-subdistrict :store="store1" v-model="form.addressContactSubDistrict" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                    <div>
                      <span>{{ $t('address.amphoe_or_zone') }}</span>
                      <addressinput-district :store="store1" v-model="form.addressContactDistrict" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-2">
                    <div>
                      <span>{{ $t('project.province') }}</span>
                      <addressinput-province :store="store1" v-model="form.addressContactProvince" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                    </div>
                    <div>
                      <span>{{ $t('project.postal_code') }}</span>
                      <addressinput-zipcode :store="store1" v-model="form.addressContactZipcode" label=""
                        :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" type="text" />
                    </div>
                  </div>
                </v-card>

                <div>
                  <h3 class="my-5">{{ $t('customer.emergency_contact_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('market.contact_person') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.contact_person')"
                      v-model="form.emergencyContactName"></v-text-field>
                  </div>
                  <div>
                    <PhoneNumber
                      ref="inputPhoneNumber"
                      :tel.sync="form.emergencyContactTel"
                      :interTel.sync="form.emergencyContactInterTel"
                      flat 
                      background-color="grey lighten-4" 
                      solo 
                      :phoneLabel="`${$t('account.phone_number')}`"
                      required
                      type="text"
                    />
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('companion') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('companion')"
                      v-model="form.emergencyContactRelation"></v-text-field>
                  </div>
                  <div></div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('income.income_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('income.income_per_year') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('income.income_per_year')"
                      v-model="form.incomePerYear"></v-text-field>
                  </div>
                  <div>
                    <span>{{ $t('market.business_start_year') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.business_start_year')"
                      v-model="form.businessStartYear"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('market.business_start_year_in_market') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.business_start_year_in_market')"
                      v-model="form.rentalStartYear"></v-text-field>
                  </div>
                  <div></div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.social_media_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>Facebook</span>
                    <v-icon class="ml-2" style="color:#4267B2;">mdi-facebook</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Facebook"
                      v-model="form.facebook"></v-text-field>
                  </div>
                  <div>
                    <span>Instagram</span>
                    <v-icon class="ml-2" style="color:#8a3ab9;">mdi-instagram</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Instagram"
                      v-model="form.instagram"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>LINE</span>
                    <img src="../assets/icons/line.svg" alt="line-icon" height="24" width="24"
                      class="ml-2 inline-block" />
                    <v-text-field flat background-color="grey lighten-4" solo label="LINE ID"
                      v-model="form.lineId"></v-text-field>
                  </div>
                  <div>
                    <span>Youtube</span>
                    <v-icon class="ml-2" style="color:#FF0000;">mdi-youtube</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Youtube"
                      v-model="form.youtube"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>TikTok</span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" class="ml-2 inline-block">
                      <path
                        d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
                    </svg>
                    <v-text-field flat background-color="grey lighten-4" solo label="TikTok"
                      v-model="form.tiktok"></v-text-field>
                  </div>

                </div>
              </div>
              <div class="grid grid-cols-1 gap-2" v-if="customerTypeString.code == 1">
                <div>
                  <h3 class="my-5">{{ $t('customer.company_data') }}</h3>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('customer.company_name_title') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('customer.company_name_title')"
                      v-model="form.companyName" :rules="[rules.required]"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('address.company_branch') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('address.company_branch')"
                      v-model="form.companyBranchName"></v-text-field>
                  </div>
                  <div>
                    <EditTaxId showLabel :showWarning='customerTypeString.code == 1 ? true : false'
                      :getLabel="$t('tax.tax_id_number_another_form')" v-model='form.citizenId' :getIsVat="true" getIsExport
                      @input="form.citizenId = $event" :getRules="rules" :isCreate="event == 'create' ? true : false"
                      @onWriteData="onWriteData" />
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.company_address') }}</h3>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('project.house_number_or_building_name_village') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('project.address_line_one')"
                      v-model="form.addressStreet"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('address.sub_district_or_district') }}</span>
                    <addressinput-subdistrict v-model="form.addressSubDistrict" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                  <div>
                    <span>{{ $t('address.amphoe_or_zone') }}</span>
                    <addressinput-district v-model="form.addressDistrict" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('project.province') }}</span>
                    <addressinput-province v-model="form.addressProvince" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" />
                  </div>
                  <div>
                    <span>{{ $t('project.postal_code') }}</span>
                    <addressinput-zipcode v-model="form.addressZipcode" label=""
                      :inputClass="`grey mb-5 lighten-4 px-3 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`" type="text" />
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.general_contact_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <div class="d-flex gap-2" v-for="(tel, index) in form.tels_tmp">
                      <PhoneNumber
                        ref="inputPhoneNumber"
                        :tel.sync="form.tels_tmp[index]"
                        :interTel.sync="form.interTels_tmp[index]"
                        flat 
                        background-color="grey lighten-4" 
                        solo 
                        :phoneLabel="`${$t('account.phone_number')} #${index + 1}`"
                        required
                        type="text"
                        :append-icon="index - 1 < 0 ? `mdi-plus` : `mdi-minus`"
                        @click:append="index - 1 < 0 ? form.tels_tmp.push('') : removeTel(index)"
                      />
                    </div>
                  </div>
                  <div>
                    <template v-for="(email, index) in form.emails_tmp">
                      <span>{{ $t('account.email') }} #{{ index + 1 }}</span>
                      <v-text-field flat background-color="grey lighten-4" v-model="form.emails_tmp[index]"
                        :key="`mailxx` + index" solo :label="$t('account.email')" required @click:append="
                          index - 1 < 0
                            ? form.emails_tmp.push('')
                            : removeEmail(index)
                          " :append-icon="index - 1 < 0 ? `mdi-plus` : `mdi-minus`"></v-text-field>
                    </template>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-2">
                  <div>
                    <span>{{ $t('website') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('website')"
                      v-model="form.website"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('profile') }}</span>
                    <v-file-input ref="profileImage" accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                      :label="$t('profile')" @change="uploadFile($event, form.profileImages_tmp)" flat v-model="profileImage_tmp"
                      background-color="grey lighten-4" solo></v-file-input>
                    <div class="image-list-box" v-if="form.profileImages_tmp && form.profileImages_tmp.length">
                      <div outlined v-for="(citizen, index) of form.profileImages_tmp" :key="`profilexx_${index}`"
                        class="image-list-box-in">
                        <img v-if="$helper.isImage(citizen.url)" :src="citizen.url" />
                        <div v-else class="file-box">
                          <div>
                            <div class="file-name">{{ (citizen.name).split('.')[0] }}</div>
                            <div>.{{ (citizen.name).split('.')[1] }}</div>
                          </div>
                        </div>
                        <v-btn small elevation="0" color="error" icon
                          @click="form.profileImages_tmp.splice(`${index}`, 1)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span>{{ $t('customer.company_document') }}</span>
                    <v-file-input ref="citizenImage" accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :label="$t('customer.company_document')" @change="uploadFile($event, form.citizenCardImages_tmp)" v-model="citizenImage_tmp"
                      flat background-color="grey lighten-4" solo></v-file-input>
                    <div class="image-list-box" v-if="form.citizenCardImages_tmp && form.citizenCardImages_tmp.length">
                      <div outlined v-for="(citizen, index) of form.citizenCardImages_tmp" :key="`profilexx_${index}`"
                        class="image-list-box-in">
                        <img v-if="$helper.isImage(citizen.url)" :src="citizen.url" />
                        <div v-else class="file-box">
                          <div>
                            <div class="file-name">{{ (citizen.name).split('.')[0] }}</div>
                            <div>.{{ (citizen.name).split('.')[1] }}</div>
                          </div>
                        </div>
                        <v-btn small elevation="0" color="error" icon
                          @click="form.citizenCardImages_tmp.splice(`${index}`, 1)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.main_contact') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('market.contact_person') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.contact_person')"
                      v-model="form.emergencyContactName"></v-text-field>
                  </div>
                  <div>
                    <PhoneNumber
                      ref="inputPhoneNumber"
                      :tel.sync="form.emergencyContactTel"
                      :interTel.sync="form.emergencyContactInterTel"
                      flat 
                      background-color="grey lighten-4" 
                      solo 
                      :phoneLabel="`${$t('account.phone_number')}`"
                      required
                      type="text"
                    />
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('companion') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('companion')"
                      v-model="form.emergencyContactRelation"></v-text-field>
                  </div>
                  <div>
                    <span>{{ $t('account.email') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('account.email')"
                      v-model="form.emergencyContactEmail"></v-text-field>
                  </div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('income.income_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('income.income_per_year') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('income.income_per_year')"
                      v-model="form.incomePerYear"></v-text-field>
                  </div>
                  <div>
                    <span>{{ $t('market.business_start_year') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.business_start_year')"
                      v-model="form.businessStartYear"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>{{ $t('market.business_start_year_in_market') }}</span>
                    <v-text-field flat background-color="grey lighten-4" solo :label="$t('market.business_start_year_in_market')"
                      v-model="form.rentalStartYear"></v-text-field>
                  </div>
                  <div></div>
                </div>
                <div>
                  <h3 class="my-5">{{ $t('customer.social_media_data') }}</h3>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>Facebook</span>
                    <v-icon class="ml-2" style="color:#4267B2;">mdi-facebook</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Facebook"
                      v-model="form.facebook"></v-text-field>
                  </div>
                  <div>
                    <span>Instagram</span>
                    <v-icon class="ml-2" style="color:#8a3ab9;">mdi-instagram</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Instagram"
                      v-model="form.instagram"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>LINE</span>
                    <img src="../assets/icons/line.svg" alt="line-icon" height="24" width="24"
                      class="ml-2 inline-block" />
                    <v-text-field flat background-color="grey lighten-4" solo label="LINE ID"
                      v-model="form.lineId"></v-text-field>
                  </div>
                  <div>
                    <span>Youtube</span>
                    <v-icon class="ml-2" style="color:#FF0000;">mdi-youtube</v-icon>
                    <v-text-field flat background-color="grey lighten-4" solo label="Youtube"
                      v-model="form.youtube"></v-text-field>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <span>TikTok</span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" class="ml-2 inline-block">
                      <path
                        d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
                    </svg>
                    <v-text-field flat background-color="grey lighten-4" solo label="TikTok"
                      v-model="form.tiktok"></v-text-field>
                  </div>

                </div>
              </div>
              <div class="my-5 justify-space-between" style="width: 100%"></div>
              <!-- {{ form.incomePerYear }} -->
              <div class="flex items-center justify-between">
                <h3 class="my-5">{{ $t('payment.bank_data') }}</h3>
                <v-btn small elevation="0" color="info" class="ml-3" @click="formBankDialog = true">
                  <v-icon>mdi-plus</v-icon>{{ $t('payment.add_account') }}
                </v-btn>
              </div>
              <div class="grid grid-cols-1 gap-2">
                <div>
                  <div v-for="(bank, index) in form.bankAccounts" :key="`bankAccount_` + index">
                    <div class="p-3 my-2 rounded shadow">
                      <div class="flex items-center justify-between">
                        <div class="text-sm">
                          <span class="text-lg primary--text">
                            {{
                              bank.accountNumber
                            }}
                          </span>
                          {{ $t('bank_short_name') }}{{
                            getBank(bank.bankCode)
                            ? getBank(bank.bankCode).name
                            : "-"
                          }}
                          {{ bank.accountName }}
                        </div>

                        <v-btn small elevation="0" color="error" icon @click="removeBankAccount(index)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <!-- Commit Again Comment Test -->
                  <div v-if="form.bankAccounts ? form.bankAccounts.length < 1 : false
                    " class="p-3 bg-white rounded shadow">{{ $t('validate.no_bank_account_data_can_add_bank_account') }}</div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-2">
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" elevation="0" @click="show = false" v-show="close">{{ $t('close') }}</v-btn>
            <v-btn color="success" elevation="0" type="submit" :loading="isLoading" :disabled="isLoading">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- loading dialog -->
    <v-dialog v-model="isFormImageLoading" persistent max-width="500px">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="white" size="64"></v-progress-circular>
          <v-spacer></v-spacer>
          <span class="display-1 white--text">{{ $t('upload.uploading') }}</span>
        </v-card-text>
        <v-snackbar v-model="isError" color="error">{{ $t('upload.error_add_user') }}</v-snackbar>
      </v-card>
    </v-dialog>
    <dialog-with-timeout v-model="isInputError" :timeout="2000" :classColor="`warning white--text`">
      <span class="text-lg">{{ $t('validate.some_information_is_not_correct_please_check_again') }}</span>
    </dialog-with-timeout>
    <FormBank v-model="formBankDialog" @onSave="addBankAccount"></FormBank>
    <v-dialog v-model="isDuplicateCustomer" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="warning text-white">
          <h4>{{ $t('validate.have_customer_in_system_do_you_want_to_add_customer_again') }}</h4>
        </v-card-title>
        <v-card-text>
          <template v-if="duplicateCustomers">
            <v-card v-for="customer in duplicateCustomers" :key="customer.objectId" class="mt-4">
              <v-card-text class="pt-2">
                <h4>{{ customer.fullNameNoTitle }}</h4>
                <div><b>{{ $t('number_another_format') }} : </b> {{ customer.fullTels || "-" }}</div>
                <div>
                  <b v-if="customer.type == 'company'">{{ $t('tax.tax_id_number_another_form') }} : </b>
                  <b v-else>{{ $t('account.citizen_id_label') }} : </b>
                  {{ customer.citizenId || "-" }}
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions class="border-t">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="isDuplicateCustomer = false" :disabled="isLoading">{{ $t('close') }}</v-btn>
          <v-btn color="success" type="submit" elevation="0" :disabled="isLoading" @click="saveCustomer()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AddressComponent from "./AddressComponent";
import FormBank from "./FormBank";
import DialogWithTimeout from "./DialogWithTimeout.vue";
import CardReaderBox from "./CardReaderBox.vue";
import lineIcon from "../assets/icons/line.svg";
import EditTaxId from "@/components/EditTaxId.vue";
import SelectPhoneCode from "./SelectPhoneCode.vue";
import PhoneNumber from "./PhoneNumber.vue";

import { DataStore } from "vue-thailand-address";
import { mapActions, mapGetters } from "vuex";
import { Banking, Customer, FileUpload } from "../classes";

export default {
  components: {
    AddressComponent,
    FormBank,
    DialogWithTimeout,
    CardReaderBox,
    EditTaxId,
    SelectPhoneCode,
    PhoneNumber
  },
  name: "SearchCustomer",
  computed: {
    ...mapGetters({
      getCustomer: "customer/getCustomer",
      getReadData: "socket/getReadData",
      getProjectId: "markets/getProjectId",
    }),
    customerTypeString() {
      if (!this.form.type) {
        this.form.type = "personal";
      }
      return this.form.type == "company"
        ? { text: this.$t('customer.type.company'), code: 1 }
        : { text: this.$t('customer.type.personal'), code: 2 };
    },
    jsonNationality() {
      const nationality = require("../json/nationalities.json");
      return nationality;
    },
    jsonReligion() {
      // thai religion
      const religion = [
        { text: this.$t('religion.ศาสนาพุทธ'), value: "ศาสนาพุทธ" },
        { text: this.$t('religion.ศาสนาอิสลาม'), value: "ศาสนาอิสลาม" },
        { text: this.$t('religion.ศาสนาคริสต์'), value: "ศาสนาคริสต์" },
        { text: this.$t('religion.ศาสนาฮินดู'), value: "ศาสนาฮินดู" },
        { text: this.$t('religion.ศาสนาซิกข์'), value: "ศาสนาซิกข์" },
        { text: this.$t('religion.ลัทธิขงจื๊อ'), value: "ลัทธิขงจื๊อ" },
        { text: this.$t('religion.ศาสนาอื่น ๆ'), value: "ศาสนาอื่น ๆ" },
        { text: this.$t('religion.ไม่มีศาสนา'), value: "ไม่มีศาสนา" },
        { text: this.$t('religion.ไม่ทราบศาสนา'), value: "ไม่ทราบศาสนา" }
      ];
      return religion;
    },
    isWriteData() {
      let isWriteData = false;
      isWriteData =
        this.event == "create" || this.event == "edit" ? true : false;
      return isWriteData;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
  data() {
    return {
      lineIcon,
      addressIsSame3: false,
      addressIsSame2: false,
      addressIsSame1: false,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        texId: value => value.length == 0 || value.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        numbersOnly: value => !value || /^\d+$/.test(value) || this.$t('validate.numbers_only'),
      },
      prefixName: [],
      formBankDialog: false,
      isLoading: false,
      isError: false,
      searchDistrict: "",
      resultSearchDistrict: "",
      searchAmphoe: "",
      resultSearchAmphoe: "",
      searchValue: "",
      dialog: false,
      store1: new DataStore(),
      store2: new DataStore(),
      profileImage_tmp: null,
      citizenImage_tmp: null,
      form: {},
      birthDate: false,
      imageValue: [],
      address: [],
      isFormImageLoading: false,
      citizenCardMenu: false,
      citizenCardIssueMenu: false,
      isInputError: false,
      duplicateCustomers: null,
      isDuplicateCustomer: false,
    };
  },
  watch: {
    addressIsSame1(val) {
      if (val) {
        this.duplicateAddress("c_addr", "h_addr");
      }
    },
    addressIsSame2(val) {
      if (val) {
        this.duplicateAddress("c_addr", "ct_addr");
        this.addressIsSame3 = false;
      }
    },
    addressIsSame3(val) {
      if (val) {
        this.duplicateAddress("h_addr", "ct_addr");
        this.addressIsSame2 = false;
      }
    },
    show(val) {
      this.resetForm();
    },
    value(val) {
      if (val) {
        if (this.objectId || this.obj?.objectId) {
          this.getCustomerById();
        } else {
          this.form = new Customer({});
          this.form.type = this.customerType;
          if (
            this.isWriteData &&
            this.getReadData &&
            this.getReadData.success
          ) {
            this.setData(this.getReadData.data);
          }
        }
      }
    },
    getReadData: {
      async handler(data) {
        if (this.isWriteData && data && data.success) {
          let dataAddress = data.data
          if (dataAddress && dataAddress.subDistrict && dataAddress.district && dataAddress.province) {
            let resDataAddress = await this.store1.dataSource.find(d => d.district == dataAddress.subDistrict && d.amphoe == dataAddress.district && d.province == dataAddress.province)
            if (resDataAddress && resDataAddress.zipcode)
              dataAddress.zipcode = String(resDataAddress.zipcode)
          }
          this.setData(data.data);
        }
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    value: Boolean,
    event: String,
    obj: Object,
    objectId: String,
    customerType: String,
    close: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.prefixName = [
      { text: this.$t('account.mr'), value: "นาย" },
      { text: this.$t('account.ms'), value: "นาง" },
      { text: this.$t('account.mrs'), value: "นางสาว" }
    ];
  },
  methods: {
    async getCustomerById() {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch("customer/getCustomer", {
          id: this.objectId
        });
        this.form = { ...response };
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    isAddrDup() {
      const newAddr1 = JSON.parse(JSON.stringify(this.form));
      const newAddr2 = JSON.parse(JSON.stringify(this.form));
      const rule =
        newAddr1.addressStreet == newAddr1.addressHouseStreet &&
        newAddr1.addressSubDistrict == newAddr1.addressHouseSubDistrict &&
        newAddr1.addressDistrict == newAddr1.addressHouseDistrict &&
        newAddr1.addressProvince == newAddr1.addressHouseProvince &&
        newAddr1.addressZipcode == newAddr1.addressHouseZipcode;
      const rule2 =
        newAddr2.addressStreet == newAddr2.addressContactStreet &&
        newAddr2.addressSubDistrict == newAddr2.addressContactSubDistrict &&
        newAddr2.addressDistrict == newAddr2.addressContactDistrict &&
        newAddr2.addressProvince == newAddr2.addressContactProvince &&
        newAddr2.addressZipcode == newAddr2.addressContactZipcode;
      if (rule) {
        this.addressIsSame1 = true;
      }
      if (rule2) {
        this.addressIsSame2 = true;
      }
    },
    changePrefix() {
      const localStorageItems = localStorage.getItem("prefixName") || [];
      if (!localStorageItems.includes(this.form.title)) {
        localStorageItems.push(this.form.title);
        localStorage.setItem("prefixName", localStorageItems);
      }
    },
    getBank(code) {
      return Banking.getBank(code);
    },
    async uploadFile(e, to = []) {
      //
      //
      if (e) {
        try {
          this.isFormImageLoading = true;
          const data = await FileUpload.upload(e);
          if (data?.name && !this.$helper.isImage(data.name)) data.name = e.name
          to.push(data);
          this.isFormImageLoading = false;
        } catch (err) {
          console.log("~ err", err);
          this.isFormImageLoading = false;
        }
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    removeBankAccount(index) {
      this.form.bankAccounts.splice(index, 1);
    },
    addBankAccount(value) {
      if (this.form.bankAccounts) {
        this.form.bankAccounts.push(value);
      } else {
        Object.assign(this.form, { bankAccounts: [] });
        this.form.bankAccounts.push(value);
      }
    },
    validate() {
      let isValid = true;
      // Validate phone numbers
      if (this.$refs.inputPhoneNumber) {
        // Handle both single instance and array of refs
        const phoneRefs = Array.isArray(this.$refs.inputPhoneNumber) 
          ? this.$refs.inputPhoneNumber 
          : [this.$refs.inputPhoneNumber];
          
        phoneRefs.forEach(ref => {
          if (ref && !ref.validate()) {
            isValid = false;
          }
        });
      }
      
      // Validate form
      if (!this.$refs.form.validate()) {
        isValid = false;
      }

      return isValid;
    },
    async updateCustomer() {
      try {
        if (this.validate()) {
          this.isLoading = true;
          let imageTemp = [];
          for (let image of this.form.profileImages_tmp) {
            let t_img;
            if (image.isCardReader) {
              t_img = await this.$store.dispatch("markets/updateImageBase64", {
                fileBase64: image.imageData
              });
              imageTemp.push(t_img);
            } else {
              imageTemp.push(image);
            }
          }
          this.form.profileImages = [...imageTemp];
          this.form.citizenCardImages = this.form.citizenCardImages_tmp;
          this.form.tels = this.form.tels_tmp ? [...this.form.tels_tmp] : [""];
          this.form.interTels = this.form.interTels_tmp ? [...this.form.interTels_tmp] : [""];
          this.form.emails = this.form.emails_tmp
            ? [...this.form.emails_tmp]
            : [""];
          setTimeout(async () => {
            const update = await this.$store.dispatch(
              "customer/updateCustomer",
              this.form
            );
            this.$emit("onUpdated", update);
            this.isLoading = false;
            this.show = false;
          }, 200);
        } else {
          this.$toast.show({
            content: `${this.$t('validate.please_input_correct_data_another_format')}`,
            color: "error"
          });
        }
      } catch (err) {
        console.log("~ err", err)
        this.isError = true;
        this.isLoading = true;
      }
    },
    changeDistrict() {
      if (typeof this.resultSearchDistrict == "object") {
        this.addressSubDistrict = this.resultSearchDistrict.district;
        this.addressDistrict = this.resultSearchDistrict.amphoe;
        this.resultSearchAmphoe = this.resultSearchDistrict.amphoe;
        this.addressProvince = this.resultSearchDistrict.province;
        this.addressZipcode = this.resultSearchDistrict.zipcode;
      }
    },
    duplicateAddress(from, to) {
      const newObject = JSON.parse(JSON.stringify(this.form));
      if (from == "c_addr") {
        if (to == "h_addr") {
          this.form.addressHouseStreet = newObject.addressStreet;
          this.form.addressHouseSubDistrict = newObject.addressSubDistrict;
          this.form.addressHouseDistrict = newObject.addressDistrict;
          this.form.addressHouseProvince = newObject.addressProvince;
          this.form.addressHouseZipcode = newObject.addressZipcode;
        } else if (to == "ct_addr") {
          this.form.addressContactStreet = newObject.addressStreet;
          this.form.addressContactSubDistrict = newObject.addressSubDistrict;
          this.form.addressContactDistrict = newObject.addressDistrict;
          this.form.addressContactProvince = newObject.addressProvince;
          this.form.addressContactZipcode = newObject.addressZipcode;
        }
      } else if (from == "h_addr") {
        if (to == "c_addr") {
          this.form.addressStreet = newObject.addressHouseStreet;
          this.form.addressSubDistrict = newObject.addressHouseSubDistrict;
          this.form.addressDistrict = newObject.addressHouseDistrict;
          this.form.addressProvince = newObject.addressHouseProvince;
          this.form.addressZipcode = newObject.addressHouseZipcode;
        } else if (to == "ct_addr") {
          this.form.addressContactStreet = newObject.addressHouseStreet;
          this.form.addressContactSubDistrict =
            newObject.addressHouseSubDistrict;
          this.form.addressContactDistrict = newObject.addressHouseDistrict;
          this.form.addressContactProvince = newObject.addressHouseProvince;
          this.form.addressContactZipcode = newObject.addressHouseZipcode;
        }
      }
    },
    async createCustomer() {
      try {
        if (this.validate()) {
          this.isLoading = true;
          let imageTemp = [];
          for (let image of this.form.profileImages_tmp) {
            let t_img;
            if (image.isCardReader) {
              t_img = await this.$store.dispatch("markets/updateImageBase64", {
                fileBase64: image.imageData
              });
              imageTemp.push(t_img);
            } else {
              imageTemp.push(image);
            }
          }
          this.form.profileImages = [...imageTemp];
          this.form.citizenCardImages = this.form.citizenCardImages_tmp;
          this.form.tels = this.form.tels_tmp ? [...this.form.tels_tmp] : [""];
          this.form.interTels = this.form.interTels_tmp ? [...this.form.interTels_tmp] : [""];
          this.form.emails = this.form.emails_tmp
            ? [...this.form.emails_tmp]
            : [""];
          setTimeout(async () => {
            const create = await this.$store.dispatch(
              "customer/createCustomer",
              this.form
            );
            this.$emit("onCreated", create);
            this.resetForm();
            this.isLoading = false;
            this.show = false;
          }, 200);
        } else {
          this.$toast.show({
            content: `${this.$t('validate.please_input_correct_data_another_format')}`,
            color: "error"
          });
        }
      } catch (err) {
        console.log("~ err", err);
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onSubmitForm() {
      try {
        if (this.validate()) {
          this.isLoading = true;
          this.duplicateCustomers = await Customer.getDuplicateCustomers({
            projectId: this.getProjectId,
            citizenId: this.form.citizenId,
            tels: this.form.tels_tmp.filter(d => d),
            customerId: this.form.id
          })
          if (this.duplicateCustomers && this.duplicateCustomers.length) {
            this.isDuplicateCustomer = true
            this.isLoading = false
          } else {
            this.saveCustomer()
          }
        }
      } catch (err) {
        console.log("~ err", err)
        this.isLoading = false;
        this.isError = true;
      }
    },
    saveCustomer() {
      this.isDuplicateCustomer = false
      if (this.event == 'create') {
        this.createCustomer()
      } else {
        this.updateCustomer()
      }
    },
    addEmail() {
      this.form.emails.push("");
    },
    addTel() {
      this.form.tels.push("");
    },

    testArr() { },
    removeTel(index) {
      this.form.tels_tmp.splice(index, 1);
      this.form.interTels_tmp.splice(index, 1);
    },
    removeEmail(index) {
      this.form.emails_tmp.splice(index, 1);
    },
    resetForm() {
      this.profileImage_tmp = null;
      this.citizenImage_tmp = null;
      this.addressIsSame1 = false;
      this.addressIsSame2 = false;
      this.form = new Customer({});
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.$forceUpdate();
    },
    setData(data) {
      let {
        fullNameTH,
        momentDateOfBirth,
        gender,
        momentIssueDate,
        momentExpireDate,
        cid,
        firstAddress,
        subDistrict,
        district,
        province,
        imageData,
        zipcode
      } = data;
      this.form.title = fullNameTH.title || "";
      this.form.firstName = fullNameTH.firstName || "";
      this.form.lastName = fullNameTH.lastName || "";
      this.form.dateOfBirth = momentDateOfBirth.format("YYYY-MM-DD") || "";
      this.form.gender = gender == "male" ? "m" : gender == "female" ? "f" : "";
      this.form.citizenCardIssueDate =
        momentIssueDate.format("YYYY-MM-DD") || "";
      this.form.citizenCardExpiryDate =
        momentExpireDate.format("YYYY-MM-DD") || "";
      this.form.citizenId = cid || "";
      this.form.addressStreet = firstAddress || "";
      this.form.addressSubDistrict = subDistrict || "";
      this.form.addressDistrict = district || "";
      this.form.addressProvince = province || "";
      this.form.addressZipcode = zipcode ? (zipcode).toString() : "" || "";

      let image = {
        name: "Picture from Thai ID card",
        url: "",
        isCardReader: true,
        imageData
      };
      this.form.profileImages_tmp = [image];
      // this.form.citizenCardImages_tmp = [image];
    },
    onWriteData(dataTax) {
      if (this.customerTypeString.code == 1 && dataTax) {
        this.form.companyName = dataTax.companyName
        this.form.addressStreet = dataTax.addressStreet;
        this.form.addressSubDistrict = dataTax.Thambol;
        this.form.addressDistrict = dataTax.Amphur;
        this.form.addressProvince = dataTax.Province;
        this.form.addressZipcode = dataTax.PostCode;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";

.outline-none {
  outline: none !important;
}

.w-100 {
  width: 100%;
}

.th-address-autocomplete {
  padding: 5px 1rem !important;
  background: white;
}
</style>

<style lang="scss" scoped>
.dialog-form-customer.v-dialog .dialog-form-customer-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}

.card-in-form .v-card__text::v-deep {
  height: unset !important;
  max-height: unset !important;
  padding: 0;
}

.card-in-form img {
  height: 100px;
  width: auto;
  padding: 5px;
  margin: 0 auto;
}

.text-position {
  font-size: 15px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .v-icon {
    font-size: 12px;
  }

  span {
    font-size: 12px;
  }
}

.image-list-box {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  position: relative;
  margin-bottom: 15px;

  .image-list-box-in {
    position: relative;
    background: rgba(236, 236, 236, 0.466);
    border: 1px solid rgb(212, 212, 212);
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    min-width: 100px;

    img {
      width: auto;
      height: 120px;
      border-radius: 5px;
      object-fit: contain;
      object-position: center;
    }

    button {
      position: absolute;
      right: 5px;
      top: 5px;
      background: rgba(224, 224, 224, 0.555);
    }
  }
}
.file-box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  width: 88px;
  height: 120px;
  color: var(--v-info-base);
}
.file-name {
  width: 88px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>